// extracted by mini-css-extract-plugin
export default {"section-4":"styles_section-4__kUvLf","service":"styles_service__ss3Hj","icon":"styles_icon__mifWy"};